module.exports = __webpack_public_path__ + "img/pin-add.3ce1ab74.svg";